import { RootState } from 'editor/src/store/index';

const getHasMoreAddons = (state: RootState): boolean => state.editorModules.addons.data?.more ?? false;

export default getHasMoreAddons;
